module.exports = __webpack_public_path__ + "img/92.2.TN.279594ee.png";